import React, { useState, useEffect, useContext } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  Button,
  Box,
  ModalHeader,
  ModalFooter,
  FormControl,
  FormLabel,
  Input,
  useBreakpointValue,
  Textarea,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionIcon,
  AccordionPanel,
  Heading,
  Spinner,
  Table,
  Th,
  Thead,
  Tr,
  Tbody,
  Td,
  Center,
  Flex,
  Text,
} from "@chakra-ui/react";
import { appRequest } from "routes";
import FileViewer from "components/common/FileViewerPdfAndImage/FileViewer";
import { AppContext } from "AppProvider/AppContext";
import CommentModal from "../CommentModal/CommentModal";
import { capitalizeCharAndAddSpace } from "components/common/functions/commonFunctions";
import { combineValues } from "../function";
import AddComentModal from "../AddComentModal/AddComentModal";
import CommentDrawer from "../CommentDrawer/CommentDrawer";

type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
  file: any;
  values?: any;
  showValues?: boolean;
  level?: any;
  id?: any;
  getData?: any;
  commentData?: string;
  // handleGetPurchaseOrder: any;
  // setIsItemsOpen: any;
  isManual: boolean;
  isDisabled?: boolean;
  documentId?: any;
  type?: string;
  tagType?: string;
  documentType?: any;
  name?: string;
  selectedRows: any[];
  setSelectedRows: React.Dispatch<React.SetStateAction<any[]>>;
  commentModel: {
    selectedStatus: string;
    open: boolean;
    comment: string;
  };
  setCommentModel: React.Dispatch<
    React.SetStateAction<{
      selectedStatus: string;
      open: boolean;
      comment: string;
      isMulti?: boolean;
    }>
  >;
  handleGet: () => void;
  tableObject?: any;
};

export default function TableViewerModel({
  isOpen,
  onClose,
  file,
  values,
  showValues,
  type,
  id,
  level,
  getData,
  isManual,
  commentData,
  isDisabled = false,
  documentId,
  tagType,
  documentType,
  name,
  selectedRows,
  setSelectedRows,
  commentModel,
  setCommentModel,
  handleGet,
  tableObject,
}: ModalProps): JSX.Element {
  const { toastNotify, accountDetails, workFlowData } = useContext(AppContext);
  const [isloading, setIsLoading] = useState(false);
  const [editedValues, setEditedValues] = useState<any>({});
  const [fetchFileLoader, setFetchFileLoader] = useState(false);
  const [isCommentOpen, setIsCommentOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  // const [comment, setComment] = useState(commentData!=="-" ? commentData : '');
  const [comment, setComment] = useState("");
  let displayTables = {};

  function transformObject(inputObject: any) {
    const transformedObject: any = {};
    for (const key in inputObject) {
      transformedObject[key] = {
        originalValue: inputObject[key],
        editFieldValue: null,
      };
    }
    return transformedObject;
  }

  if (!Array.isArray(values)) {
    values = transformObject(values?.values);
    displayTables = values?.displayTables?.originalValue;
    // displayTables = values.values.displayTables
  }

  if (Array.isArray(values) && values?.length) {
    displayTables =
      values[values.length - 1].values?.displayTables?.originalValue;
  }

  const [sample, setSample] = useState({
    url: "",
    file: null,
    type: null,
    buffer: null,
  });

  useEffect(() => {
    if (isOpen) {
      getFile();
    }
  }, [isOpen]);

  const handleInvOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleInvCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleCloseCommentModal = () => {
    setIsCommentOpen(false);
  };

  const handleOpenCommentModal = () => {
    setIsCommentOpen(true);
  };

  const isCommentValid = () => {
    return comment.trim() !== "";
  };

  const getFile = async () => {
    try {
      if (file?._id) {
        setFetchFileLoader(true);
        const response: any = await appRequest("filesystem", "get", {
          id: file._id,
        });
        if (response) {
          if (response?.error) {
          } else {
            let buffer =
              typeof response === "string" ? JSON.parse(response) : response;
            buffer = new Uint8Array(buffer);

            const fileURL = URL.createObjectURL(
              new Blob([buffer], { type: file.metadata.contentType })
            );
            setSample({
              url: fileURL,
              file: file,
              type: file.metadata.contentType,
              buffer: buffer,
            });
          }
        }
      }
    } catch (error: any) {
      toastNotify({
        title: "Error",
        message: error.message,
        type: "error",
      });
    } finally {
      setFetchFileLoader(false);
    }
  };

  const viewerWidth = useBreakpointValue({ lg: true });

  let width =
    workFlowData && workFlowData?.fileViewer?.tableFile && showValues
      ? "95vw"
      : "45vw";

  const handleModalWheel = (event: React.WheelEvent<HTMLDivElement>) => {
    event.stopPropagation();
  };

  // updation of document status and comment
  const handleDocUpdate = async (
    status: string,
    level?: any,
    documentId?: any
  ) => {
    try {
      setIsLoading(true);
      let valus = combineValues(values, editedValues);

      const updatedStatus: any = {};
      updatedStatus["id"] = id;
      updatedStatus["level"] = level;
      updatedStatus["status"] = status;
      updatedStatus["comment"] = comment;
      updatedStatus["values"] = valus;
      updatedStatus["type"] = "document";
      const response: any = await appRequest(
        "document",
        "update",
        updatedStatus
      );

      if (response.status === "success") {
        toastNotify({
          title: "Updates submitted",
          message: "Updated successfully.",
        });
        setComment("");
        getData();
        onClose();
      } else {
        toastNotify({
          title: "Error",
          message: "Failed to update document.",
          type: "error",
        });
      }
      // console.log("done");
    } catch (error) {
      toastNotify({
        title: "Error",
        message: "Failed to update document.",
        type: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const renderTable = (data: any) => {
    if (!data) {
      data = {};
    }
    let { headerGroups = [], rowGroups = [] } = data;
    return (
      <Box overflowY="auto" className="customScrollBar">
        <Table variant="striped" className="drowerTable" size="sm">
          <Thead>
            {tableObject.drawerTableActive === true ? (
              <Tr>
                {tableObject.drawerTable?.map(
                  (headers: any, rowIndex: number) => {
                    if (Array.isArray(headers)) {
                    }
                    return (
                      headers &&
                      headers.isActive && (
                        <Th
                          key={`header-${rowIndex}`}
                          colSpan={headers.columnSpan}
                          rowSpan={headers.rowSpan}
                          textAlign={
                            headers.labelCenter === true ? "center" : "left"
                          }
                          // style={{
                          //   textAlign: "center",
                          //   borderRight: "1px solid white",
                          //   padding: "10px",
                          // }}
                        >
                          <Text
                            whiteSpace={
                              headers.labelNoWrap === true ? "nowrap" : "unset"
                            }
                          >
                            {headers.label}
                          </Text>
                        </Th>
                      )
                    );
                  }
                )}
              </Tr>
            ) : (
              headerGroups &&
              headerGroups?.map((headers: any, rowIndex: number) => {
                if (Array.isArray(headers)) {
                }
                return (
                  <Tr key={`headerGroup-${rowIndex}`}>
                    {Array.isArray(headers) &&
                      headers?.map(
                        (header: any, colIndex: number) =>
                          header && (
                            <Th
                              key={`header-${rowIndex}-${colIndex}`}
                              colSpan={header.columnSpan}
                              rowSpan={header.rowSpan}
                              // style={{
                              //   textAlign: "center",
                              //   borderRight: "1px solid white",
                              //   padding: "10px",
                              // }}
                            >
                              {header?.content}
                            </Th>
                          )
                      )}
                  </Tr>
                );
              })
            )}
          </Thead>
          <Tbody>
            {rowGroups &&
              rowGroups?.map((rows: any, rowIndex: number) => {
                return (
                  <Tr key={`rowsGroup-${rowIndex}`}>
                    {rows &&
                      rows?.map((row: any, colIndex: number) => {
                        const header = tableObject?.drawerTable?.[colIndex];
                        return tableObject.drawerTableActive ? (
                          header?.isActive && (
                            <Td key={`cell-${rowIndex}-${colIndex}`}>
                              <Text
                                textAlign={
                                  header.rowType === "number"
                                    ? "center"
                                    : header.rowType === "amount"
                                    ? "right"
                                    : "left"
                                }
                              >
                                {row ? row : row}
                              </Text>
                            </Td>
                          )
                        ) : (
                          <Td key={`cell-${rowIndex}-${colIndex}`}>
                            {row ? row : row}
                          </Td>
                        );
                      })}
                  </Tr>
                );
              })}
          </Tbody>
        </Table>
      </Box>
    );
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="full" isCentered>
      <ModalOverlay bg="rgba(0, 0, 0, 0.2)" />
      <ModalContent
        position="fixed"
        right={isOpen ? "0" : `-${width}`}
        top="0"
        height="100vh"
        width={viewerWidth ? width : "100vw"}
        animation={`${
          isOpen ? "slideIn" : "slideOut"
        } 0.8s ease-in-out forwards`}
      >
        <ModalHeader
          fontSize={{ base: "md", lg: "lg" }}
          color="teal.300"
          fontWeight="700"
          p=".6rem"
          ml="1rem"
        >
          {values?.Invoice_Id?.originalValue
            ? `Invoice Id: ${values?.Invoice_Id?.originalValue}`
            : "Document"}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody
          px={{ base: ".5rem", lg: "1.5rem" }}
          py=".2rem"
          overflowY="auto"
          className="customScrollBar"
          mb={{ base: "1rem", lg: "unset" }}
        >
          <Box
            display={{ base: "grid", lg: "flex" }}
            flexDirection={{ base: "column", lg: "row" }}
            gap={{ base: 1, lg: 6 }}
            h="90%"
          >
            {workFlowData &&
              workFlowData.fileViewer.tableFile &&
              (fetchFileLoader ? (
                <Box
                  h={{ base: "30vh", md: "40vh", lg: "80vh" }}
                  mb="1rem"
                  w="100%"
                  display="flex"
                  flexDirection="column"
                  justifyContent="center"
                  alignItems="center"
                >
                  <Spinner
                    size="xl"
                    thickness="4px"
                    speed="0.65s"
                    color="teal.400"
                  />
                </Box>
              ) : (
                <Box h={{ base: "30vh", md: "40vh", lg: "85vh" }} w="100%">
                  <FileViewer sample={sample} />
                </Box>
              ))}
            <Box>
              {values && showValues && (
                <Box
                  h={!isDisabled ? "85vh" : "85vh"}
                  w={{ lg: "50vw" }}
                  // p={{ base: ".6rem", lg: ".6rem .5rem" }}
                  overflowY="auto"
                  className="customScrollBar"
                  onWheel={handleModalWheel}
                  border={!displayTables ? "2px solid gray" : undefined}
                >
                  {displayTables ? (
                    renderTable(displayTables)
                  ) : (
                    <Center mt="32%">
                      <Text fontWeight="bold" cursor="pointer" fontSize="xl">
                        No Table Data are found
                      </Text>
                    </Center>
                  )}
                </Box>
              )}
            </Box>
          </Box>
        </ModalBody>
        {!isDisabled && accountDetails.role !== "admin" && accountDetails.role === "approver" && name === "Pending Approval" &&(
          <ModalFooter p="0.5rem">
            <Button
              isDisabled={isloading}
              onClick={() =>
                setCommentModel({
                  open: true,
                  selectedStatus: "approved",
                  comment: "",
                  isMulti: false,
                })
              }
              fontSize="sm"
              bg="green.500"
              color="white"
              _hover={{ bg: "green.600" }}
              mr="1rem"
              w="100px"
            >
              Accept
            </Button>
            <Button
              isDisabled={isloading}
              onClick={() =>
                setCommentModel({
                  open: true,
                  selectedStatus: "rejected",
                  comment: "",
                  isMulti: false,
                })
              }
              bg="red.500"
              _hover={{ bg: "red.600" }}
              color="white"
              w="100px"
              mr="14px"
            >
              Reject
            </Button>
          </ModalFooter>
        )}
      </ModalContent>
      <style>
        {`
          @keyframes slideIn {
            from {
              right: -${width};
            }
            to {
              right: 0;
            }
          }
          @keyframes slideOut {
            from {
              right: 0;
            }
            to {
              right: -${width};
            }
          }
          `}
      </style>
      <CommentDrawer
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
        commentModel={commentModel}
        setCommentModel={setCommentModel}
        handleGet={handleGet}
        view={true}
        isOpen={commentModel.open}
        width={width}
        onClose={handleCloseCommentModal}
        handleClose={onClose}
        selectedFile={file}
      />
    </Modal>
  );
}
